import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BlankLayout } from '@/layout';
import { requestToggle } from '@/model/global/actions';

const withFeatureToggle = <P extends PropsWithChildren<unknown>>(Component: React.ComponentType<P>) => (
  props: P,
): JSX.Element => {
  const dispatch = useDispatch();
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (!initialized) {
      (async () => {
        try {
          await requestToggle()(dispatch);
        } finally {
          setInitialized(true);
        }
      })();
    }
  }, [initialized, dispatch]);
  return initialized ? <Component {...props} /> : <BlankLayout />;
};

export default withFeatureToggle;
